module.exports = __webpack_public_path__ + "img/64.5cb97375.jpg";